import angular from 'angular';

angular.module('cloudX').factory('checkTenantConfiguration', [
  'authService',
  function(authService) {
    var getConfigurationsFromParam = function(value) {
      if (typeof value === 'undefined' || value === null) return null;
      if (angular.isArray(value)) {
        /* Allowed array format:
          [1,2]
        */
        return { reverse: false, configurations: value };
      } else if (angular.isString(value)) {
        /* Allowed string formats:
          1
          1,2
          [1,2]
          !1
          !1,2
          ![1,2]
        */
        var result = {
          reverse: false,
          configurations: [],
        };
        if (value.startsWith('!')) {
          result.reverse = true;
          value = value.substr(1);
        }
        if (value.startsWith('[') && value.endsWith(']')) {
          value = value.substr(1, value.length - 2);
        }
        if (value.match(/^[0-9]+(,[0-9])*$/)) {
          result.configurations = value.split(',').map(c => parseInt(c));
        }
        return result;
      }
      return null;
    };

    var service = function(param) {
      var auth = authService.getClaims();
      if (!auth) return false;

      if (param === 'sso') return auth['sso'] === 'True';

      var security = getConfigurationsFromParam(param);
      if (!security) return false;

      var tenantConfiguration = 0;
      try {
        tenantConfiguration = parseInt(auth.TenantConfiguration);
      } catch (ex) {
        return false;
      }
      return security.configurations.indexOf(tenantConfiguration) >= 0
        ? !security.reverse
        : security.reverse;
    };
    return service;
  },
]);
